import React, { Component } from 'react'

class CariReferenceSubmittedPg extends Component {

    state = {
        helpcontactEmail: "bsb_appointments@sfu.ca",
    }

    render() { 
        return (
            <div className="full_page_format">
                <br />

                <div className="p-grid">
                    <div className="p-col-12">

                        <label className="cari_title">
                            Thank you for providing your response.
                        </label>
                        <br />
                        <br />

                        <span className={"cari_small_text"}>
                            Should you have any questions or issues, please contact the Dean's Office, Beedie School of Business, at
                            &nbsp;
                            <strong>{this.state.helpcontactEmail}</strong>
                        </span>

                    </div>
                </div>

                <br />
                <br />
                <br />

            </div>
        );
    }
}
 
export default CariReferenceSubmittedPg;